import ReferenceArrayInput from './component';
import { ReferenceArrayInputProps } from './types';

export default ReferenceArrayInput;
export type { ReferenceArrayInputProps };
